<mat-form-field class="relative textarea-wrapper"
                [ngClass]="inputClass"
                appearance="outline"
                [hideRequiredMarker]="true"
                floatLabel="always"
                [class.mat-form-field-invalid]="ctrl?.invalid && ctrl?.touched">
  <mat-label [hidden]="!showLabel">
    <span>{{inputLabel | titlecase}}</span>
    <span *ngIf="isRequired" class="color-error">*</span>:
  </mat-label>
  <textarea matInput
            [placeholder]="placeholder"
            type="text"
            [formControl]="ctrl.control"
            class="app-textarea"
            [required]="isRequired"
            [readonly]="readonly"
            [maxlength]="maxLength"
            [errorStateMatcher]="errorMatcher()"
            [attr.data-test-id]="'input_textarea_'+testId"></textarea>

  <mat-hint *ngIf="inputHint && !isWarningVisible" class="hint d-flex">
    <span *ngIf="inputHintIcon" class="icon icon-info icon-fs-md mr-q"></span>
    <span class="fs-sm" [innerHTML]="inputHint"></span>
  </mat-hint>

  <mat-hint *ngIf="isWarningVisible" class="color-warning d-flex ai-center">
    <span class="icon icon-error icon-fs-md mr-q"></span>
    <span class="fs-sm">{{warningMessage}}</span>
  </mat-hint>

  <mat-error class="mat-error">
    <span class="icon icon-error fs-md"></span> {{getErrorMessage()}}</mat-error>
</mat-form-field>
